export default __webpack_public_path__ + "static/media/RobotoSlab.9fdf5c2c.ttf";